// @flow

import React, { type Element, useEffect } from 'react'
import { TextField } from '@material-ui/core'
import {
  useValidationResult,
  handleChange,
  handleBlur,
  getErrorMsg,
} from '../../../lib/CoreValidations'
import { core } from '../../../lib/WasmCache'

type Props = {
  initialValue: string,
  value: string,
  setValue: (string) => void,
  setIsValid: (boolean) => void,
}

function LastNameField({
  initialValue,
  value,
  setValue,
  setIsValid,
}: Props): Element<typeof React.Fragment> {
  const [validationResult, onChange, onBlur] = useValidationResult(core.validateLastName)

  useEffect(() => {
    if (!initialValue) {
      return
    }

    const newResult = onChange(initialValue)

    setIsValid(newResult.is_success)
    setValue(initialValue)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue])

  return (
    <TextField
      id="last-name"
      label="Last name"
      variant="outlined"
      fullWidth
      required
      error={!validationResult.is_success}
      helperText={getErrorMsg(validationResult)}
      value={value}
      onChange={(e) => handleChange(e.target.value, onChange, setIsValid, setValue)}
      onBlur={(e) => handleBlur(e.target.value, onBlur, setIsValid)}
    />
  )
}

export default LastNameField
